export const INTERACTIVE_ELEMENT_FOCUS_VISIBLE = {
  '&:focus-visible': {
    outlineOffset: '-1px',
    outline: '1px auto',
    // outline width and style will be ignored by non-webkit browsers if this outline-color isn't declared separately
    outlineColor: '-webkit-focus-ring-color'
  },
  // Firefox only: https://www.browserstack.com/guide/create-browser-specific-css#toc5
  '@supports (-moz-appearance:none)': {
    '&:focus-visible': {
      outlineOffset: '-2px',
      outlineColor: 'Highlight'
    }
  }
};